import React from "react";

export default function  ComparePlans() {
  return (
    <section id="compare-plans" className="lg:tw-py-20 tw-py-10 tw-bg-gray-50">
      <div className="tw-max-w-7xl tw-mx-auto tw-px-6">
        <div className="tw-text-center tw-mb-16">
          <h2 className="tw-text-2xl lg:tw-text-4xl tw-font-bold tw-text-fintoo-blue tw-mb-6">
            Compare. Choose. Protect.
          </h2>
          <p className="tw-text-lg  lg:tw-text-xl  tw-text-gray-700">
            We’ve simplified the decision-making process. Compare premiums,
            features, claim settlement ratios, and riders — all in one place.
          </p>
        </div>

        <div className="tw-bg-white tw-rounded-3xl tw-shadow-xl tw-overflow-hidden">
          <div className="tw-overflow-x-auto">
            <table className="tw-w-full">
              <thead className="tw-bg-gradient-to-b tw-from-fintoo-blue tw-to-[#1b53a3] tw-text-white">
                <tr>
                  <th className="tw-px-6 tw-py-4 tw-text-left tw-font-semibold">
                    Feature
                  </th>
                  <th className="tw-px-6 tw-py-4 tw-text-center tw-font-semibold">
                    Generali Central Flexi Term
                  </th>
                  <th className="tw-px-6 tw-py-4 tw-text-center tw-font-semibold">
                    Max Life Smart Term
                  </th>
                  <th className="tw-px-6 tw-py-4 tw-text-center tw-font-semibold">
                    Bajaj Allianz Smart Protect
                  </th>
                </tr>
              </thead>
              <tbody className="tw-divide-y tw-divide-gray-100">
                <tr>
                  <td className="tw-px-6 tw-py-4 tw-font-medium tw-text-gray-900">
                    Claim Settlement Ratio
                  </td>
                  <td className="tw-px-6 tw-py-4 tw-text-center">96.1%</td>
                  <td className="tw-px-6 tw-py-4 tw-text-center tw-text-green-600 tw-font-semibold">
                    99.5%
                  </td>
                  <td className="tw-px-6 tw-py-4 tw-text-center">98.1%</td>
                </tr>
                <tr className="tw-bg-gray-50">
                  <td className="tw-px-6 tw-py-4 tw-font-medium tw-text-gray-900">
                    Policy Term
                  </td>
                  <td className="tw-px-6 tw-py-4 tw-text-center">Up to 85 years</td>
                  <td className="tw-px-6 tw-py-4 tw-text-center">Up to 85 years</td>
                  <td className="tw-px-6 tw-py-4 tw-text-center">Up to 75 years</td>
                </tr>
                <tr>
                  <td className="tw-px-6 tw-py-4 tw-font-medium tw-text-gray-900">
                    Minimum Premium (₹/mo)
                  </td>
                  <td className="tw-px-6 tw-py-4 tw-text-center">₹600</td>
                  <td className="tw-px-6 tw-py-4 tw-text-center">₹700</td>
                  <td className="tw-px-6 tw-py-4 tw-text-center tw-text-green-600 tw-font-semibold">
                    ₹500
                  </td>
                </tr>
                <tr className="tw-bg-gray-50">
                  <td className="tw-px-6 tw-py-4 tw-font-medium tw-text-gray-900">
                    Riders Available
                  </td>
                  <td className="tw-px-6 tw-py-4 tw-text-center">Yes (CI, ADB)</td>
                  <td className="tw-px-6 tw-py-4 tw-text-center">Yes (CI, WP)</td>
                  <td className="tw-px-6 tw-py-4 tw-text-center">
                    Yes (CI, Income Rider)
                  </td>
                </tr>
                <tr>
                  <td className="tw-px-6 tw-py-4 tw-font-medium tw-text-gray-900">
                    Unique Feature
                  </td>
                  <td className="tw-px-6 tw-py-4 tw-text-center">
                    Life stage flexibility
                  </td>
                  <td className="tw-px-6 tw-py-4 tw-text-center">
                    Multiple payout modes
                  </td>
                  <td className="tw-px-6 tw-py-4 tw-text-center">
                    Affordable + Income option
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
};

 